export const formHeaderTheme = {
  bg: 'palette.surface.2',
  borderColor: 'palette.surface.5',
  borderWidth: '1px',
  boxShadow: 'palette.black:0.06',
  cancelNameButton: 'palette.error.20',
  name: 'palette.tertiary.95',
  saveNameButton: 'palette.success.20',
};
